import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import useAxios from '../../hooks/useAxios';
import { User } from '../../Models/User';

interface UserData {
  uuid: string;
  email: string;
  firstname: string;
  lastname: string;
  role: string;
  isActivated: boolean;
  createdAt?: string;
}

export function useUsers() {
  const { getWithAxios } = useAxios();

  return useQuery({
    queryKey: queryKeys.users.list(),
    queryFn: async (): Promise<User[]> => {
      const response = await getWithAxios('/admin/users');
      if (Array.isArray(response)) {
        return response.map((u: UserData) => new User({
          ...u,
          projects: [],
        }));
      }
      return [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
